export default __webpack_public_path__ + "static/media/element_99.5c6ed379.webp";